<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 4.5C3 3.54297 3.76562 2.75 4.75 2.75H15.25C16.207 2.75 17 3.54297 17 4.5V12.375C17 13.3594 16.207 14.125 15.25 14.125H11.4492L8.05859 16.668C7.92188 16.7773 7.75781 16.7773 7.59375 16.7227C7.45703 16.6406 7.375 16.5039 7.375 16.3125V14.125H4.75C3.76562 14.125 3 13.3594 3 12.375V4.5ZM7.15625 6.6875C6.77344 6.6875 6.5 6.98828 6.5 7.34375C6.5 7.72656 6.77344 8 7.15625 8H12.8438C13.1992 8 13.5 7.72656 13.5 7.34375C13.5 6.98828 13.1992 6.6875 12.8438 6.6875H7.15625ZM7.15625 9.3125C6.77344 9.3125 6.5 9.61328 6.5 9.96875C6.5 10.3516 6.77344 10.625 7.15625 10.625H10.2188C10.5742 10.625 10.875 10.3516 10.875 9.96875C10.875 9.61328 10.5742 9.3125 10.2188 9.3125H7.15625Z"
      fill="currentColor"
    />
  </svg>
</template>
